<template>
  <b-sidebar :id="'sidebar-import-recording-sesion-' + reuseClassroom.id" :title="reuseClassroom.name" sidebar-class="bb-offcanvas-panel-wrap-no-box full"
             width="100%" v-on:shown="initClassroomsRecordings" v-on:hidden="clearRecordings"
             bg-variant="white" right backdrop-variant="dark" backdrop shadow>
    <template #default="{ hide }">
      <div class="panel-main-content">
        <header class="page-header page-header-collapsed">
          <div class="page-title-wrapper">
            <h1 class="page-title">Grabaciones: <bdi>{{reuseClassroom.name}}</bdi></h1>
          </div>
        </header>
        <div id="body-content" class="body-content instances-container">
          <div v-if="!loading" class="full-width-content--small">
            <div v-if="!recordings.length" class="no-content no-results">
              <span class="no-content-title">No encontramos grabaciones que coincidan con esos criterios.</span>
            </div>
            <table v-if="recordings.length" class="content-table">
              <tbody>
              <tr class="content-table__header">
                <th class="medium-4">Nombre de la sesión/nombres de la grabación</th>
                <th class="medium-2">Fecha</th>
                <th class="medium-1">Duración</th>
                <th class="medium-1 recording-status-header content-table__th-tooltip">Estado
                </th>
                <th class="medium-1">Subtítulos</th>
              </tr>
              <tr v-for="recording in recordings" v-bind:key="recording.id" v-if="recording.targetSystem === 'COLLABSECONDARY'"
                v-bind:class="{'element-list-row--inactive':!recording.published, 'element-list-row':recording.published}">
                <td class="break-word content-table__emphasis buttonprevent">
                  <bdi v-if="recording.targetSystem == 'COLLAB'" class="opacity-unpublished">{{ recording.sessionName }}/</bdi>
                  <bdi v-if="recording.targetSystem == 'COLLAB'" class="opacity-unpublished">{{ recording.mediaName }}</bdi>
                  <bdi v-else class="opacity-unpublished">{{ recording.name }}</bdi>
                </td>
                <td class="date">
                  <span class="inline-column-title ng-scope">Fecha:</span>
                  <span>{{ recording.endTime | moment("D/M/YY HH:mm") }}</span>
                </td>
                <td class="duration-column">
                  <span class="inline-column-title ng-scope">Duración:</span>
                  <span>{{ msToTime(recording.duration) }}</span>
                </td>
                <td class="status-column" >
                  <span class="inline-column-title ng-scope">Estado:</span>
                  <span class="status-column__text">
                    <check-circle-outline-icon fill-color="#007d2c" :size="20"/>
                    <span>Listo</span>
                  </span>
                </td>
                <td class="status-column">
                  <span class="inline-column-title ng-scope">Subtítulos:</span>
                  <span v-if="recording.targetSystem === 'COLLABSECONDARY' && recording.withCaptions === 1" class="status-column__text">
                    <closed-caption-outline-icon fill-color="#999999" :size="20"/>
                    <span>Generando</span>
                  </span>
                  <span v-else-if="recording.targetSystem === 'COLLABSECONDARY' && recording.withCaptions === 2" class="status-column__text">
                    <closed-caption-outline-icon fill-color="#262626" :size="20"/>
                    <span>Listo</span>
                  </span>
                  <span v-else-if="recording.targetSystem === 'COLLABSECONDARY' && recording.withCaptions === 3" class="status-column__text">
                    <closed-caption-outline-icon fill-color="#c23e37" :size="20"/>
                    <span>Fallido</span>
                  </span>
                  <span v-else-if="recording.targetSystem === 'COLLABSECONDARY'" class="status-column__text">
                    <closed-caption-outline-icon fill-color="#999999" :size="20"/>
                    <span>Sin generar</span>
                  </span>
                  <span v-else class="status-column__text">
                    <span>No disponible</span>
                  </span>
                </td>
                <td class="item-controls" style="text-align: unset;">
                  <button class="button secondary short button-action-reuse-session" v-b-toggle.sidebar-no-header="'sidebar-import-recording-import'"
                    @click="reuseSessionRecordingImport(recording)">{{ $t("sessions.reusemodal.reuse") }}</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ImportRecordingImportSidebar
        :classroomOrigin="classroomOrigin"
        :recordingImport="recordingImport"
        :reuseClassroom="reuseClassroom">
      </ImportRecordingImportSidebar>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import CheckCircleOutlineIcon from 'vue-material-design-icons/CheckCircleOutline.vue'
import SyncIcon from 'vue-material-design-icons/Sync.vue'
import CloudDownloadOutlineIcon from 'vue-material-design-icons/CloudDownloadOutline.vue'
import ClosedCaptionOutlineIcon from 'vue-material-design-icons/ClosedCaptionOutline.vue'
import PlayOutlineIcon from 'vue-material-design-icons/PlayOutline.vue'
import LoadingIcon from 'vue-material-design-icons/Loading.vue'
import DotsHorizontalCircleOutlineIcon from 'vue-material-design-icons/DotsHorizontalCircleOutline.vue'
import EyeOffOutlineIcon from 'vue-material-design-icons/EyeOffOutline.vue'
import EyeOutlineIcon from 'vue-material-design-icons/EyeOutline.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import ImportRecordingImportSidebar from './ImportRecordingImportSidebar'

export default {
  name: 'ImportRecordingSesionsRecordingsSidebar',
  components: {
    CloseIcon, KeyboardReturnIcon, PlayOutlineIcon, CheckCircleOutlineIcon, SyncIcon, LoadingIcon, CloudDownloadOutlineIcon, DotsHorizontalCircleOutlineIcon, ClosedCaptionOutlineIcon, EyeOffOutlineIcon, EyeOutlineIcon, ImportRecordingImportSidebar},
  mixins: [utilitiesMixin],
  props: ['classroomOrigin', 'iconColor', 'reuseClassroom'],
  data () {
    return {
      loading: false,
      player_url: null,
      player_id: null,
      player_title: null,
      player_captions_url: null,
      chat: null,
      recordings: [],
      captions_language: null,
      recordingImport: null
    }
  },
  methods: {
    initClassroomsRecordings () {
      let vueComponent = this
      this.loading = true

      let filterParams = new URLSearchParams()
      filterParams.append('classroomId', this.reuseClassroom.id)

      // CMM: Se recuperan las grabaciones asociadas a la clase
      window.axios.get('recordings/', {params: filterParams}).then((response) => {
        // CMM: Se efectúan las matrículas en los grupos y se recuperan las URLs de acceso
        vueComponent.recordings = response.data
        this.loading = false
      })
    },
    clearRecordings () {
      this.recordings = []
    },
    reuseSessionRecordingImport (recording) {
      this.recordingImport = recording
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Modals/ImportRecordingSesionsRecordingsSidebar.vue